import type { PluginDefinition } from '@/plugins/types';
import { APP_VERSION } from '@/app/version';
import { HelpFab } from './HelpFab';

export const helpAssistantPlugin: PluginDefinition = {
  id: 'help-assistant',
  name: 'KI-Hilfe',
  version: APP_VERSION,
  description: 'Kontextueller KI-Assistent für SophoGraph-Bedienungsfragen.',
  internal: true,
  enabledByDefault: true,
  group: 'core',
  initializationOrder: 90,
  initialize: () => undefined,
  slots: {
    utilityPanels: () => <HelpFab />,
  },
};
